import { JsonDecoder } from 'ts.data.json';

export interface Decor {
    label: string;
    imageUri: string | null;
    decorNumber: string;
    articleNumber: string;
    price: number;
    squareMetersPerPackage: number;
    ean: string;
}

export interface Floor {
    floorTypeLabel: string;
    floorFamilyId: string;
    floorFamilyLabel: string;
    floorId: string;
    floorLabel: string;
    decors: Decor[];
    colorId: string;
    doesNotNeedInsulation: boolean;
}

export type Floors = Floor[];

export function fetchFloors(locale: string): Promise<Floors> {
    return fetch('/api/shopping-planner/floors', {
        headers: {
            'Accept-Language': locale,
            credentials: 'include',
        },
    })
        .then((response) => response.json())
        .then((json) => floorDataResponseDecoder.decodeToPromise(json))
        .then((response) => response.data);
}

interface FloorDataResponse {
    data: Floors;
}

const floorDataResponseDecoder = JsonDecoder.object<FloorDataResponse>(
    {
        data: JsonDecoder.array(
            JsonDecoder.object(
                {
                    floorTypeLabel: JsonDecoder.string,
                    floorFamilyId: JsonDecoder.string,
                    floorFamilyLabel: JsonDecoder.string,
                    floorId: JsonDecoder.string,
                    floorLabel: JsonDecoder.string,
                    colorId: JsonDecoder.string,
                    doesNotNeedInsulation: JsonDecoder.boolean,
                    decors: JsonDecoder.array(
                        JsonDecoder.object(
                            {
                                label: JsonDecoder.string,
                                imageUri: JsonDecoder.nullable(JsonDecoder.string),
                                articleNumber: JsonDecoder.string,
                                price: JsonDecoder.number,
                                squareMetersPerPackage: JsonDecoder.number,
                                decorNumber: JsonDecoder.string,
                                ean: JsonDecoder.string,
                            },
                            'Decor'
                        ),
                        'Decors'
                    ),
                },
                'Floor'
            ),
            'Floors'
        ),
    },
    'FloorDataResponse'
);
